<template>
    <v-card :class="{'px-3 py-4': $vuetify.breakpoint.smAndDown, 'px-5 py-5': $vuetify.breakpoint.mdAndUp}" :width="$vuetify.breakpoint.lgAndUp ? 1134 : 'auto'">
        <v-form @submit.prevent>
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('modal_event_reg')">{{$t("закрыть")}}</v-icon>
            <v-card-title :class="{'mb-3 headline': $vuetify.breakpoint.smAndDown, 'mb-5 display-1': $vuetify.breakpoint.mdAndUp}">
                {{$t("Зарегистрироваться на мероприятие")}}
            </v-card-title>
            <div class="news_title">{{ current_item_news.title }}</div>
            <v-layout column>
                <v-layout row wrap>
                    <v-flex md4 sm6 xs12
                            :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Фамилия")}} *</div>
                        <inputBase :placeholder="$t('Введите фамилию')" :value="user.family" @change="set_family($event.target.value)" />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            :class="{'mt-4': $vuetify.breakpoint.xs, 'pr-0': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Имя")}}  *</div>
                        <inputBase :placeholder="$t('Введите имя')" :value="user.name" @change="set_name($event.target.value)" />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            :class="{'mt-4': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">E-mail  *</div>
                        <inputBase placeholder="mail@email.com" :value="user.email" @change="set_email($event.target.value)" />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mt-4
                            :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Управление")}} *</div>
                        <v-select
                            solo
                            append-icon=""
                            class="input"
                            :items="[$t('Лукойл-Москва'),$t('Лукойл-Тюмень'),$t('Технефтегаз')]"
                            :placeholder="$t('Выберите управление')"
                            :value="user.directorate ? user.directorate : user.company_name"
                            @change="set_directorate($event)"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mt-4
                            :class="{'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Организация")}} *</div>
                        <v-select
                            solo
                            append-icon=""
                            class="input"
                            :items="[$t('Лукойл-Москва'),$t('Лукойл-Тюмень'),$t('Технефтегаз')]"
                            :placeholder="$t('Выберите организацию')"
                            :value="user.company_name"
                            @change="set_org($event)"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mt-4
                            :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Должность")}} *</div>
                        <inputBase :placeholder="$t('Укажите должность')" :value="user.position" @change="set_position($event.target.value)" />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            mt-4
                            :class="{'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Формат участия")}}</div>
                        <v-select
                            solo
                            append-icon=""
                            class="input"
                            :items="event_types"
                            :placeholder="$t('Выберите формат участия')"
                            @change="event_type($event)"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                </v-layout>
            </v-layout>
            <v-card-actions :class="{'mt-4': $vuetify.breakpoint.smAndDown, 'mt-5': $vuetify.breakpoint.mdAndUp}">
                <v-layout wrap align-center>
                    <buttonRed :class="{'flex xs12 mr-0 mb-2': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}" @click.native="register_event()">{{$t("Регистрация")}}</buttonRed>
                    <div class="grey-text">{{$t("* - поля, обязательные для заполнения")}}</div>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red';
import inputBase from '@/components/ui/inputs/base/input';
// import {mask} from 'vue-the-mask';
import {mapGetters, mapMutations, mapActions} from 'vuex';
// import {get, post} from '@/lib/axios';
import api from '../../../../api/index.js';

export default {
  components: {
    buttonRed,
    inputBase,
  },
  props: {
    current_item_news: {
      type: Object,
    },
  },
  data() {
    return {
      register_info: {
        family      : '',
        name        : '',
        email       : '',
        directorate : '',
        organization: '',
        position    : '',
        event_type  : '',
      },
      registered_event: {
        'format': '',
        'user'  : {
          'name'    : '',
          'email'   : '',
          'company' : '',
          'position': '',
        },
      },
    };
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('registration_event', [
      'user_id',
      'get_event_form',
      'get_get_name',
      'get_family',
      'get_get_email',
      'get_get_department',
      'get_get_organization',
      'get_get_position',
      'form',
    ]),
    ...mapGetters('news_main', [
      'event_types',
    ]),
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  methods: {
    ...mapActions('registration_event', ['register_event']),
    ...mapMutations('news_main/detail', ['CLOSE_MODAL']),
    ...mapMutations('registration_event', [
      'SET_EVENT_FORM',
      'SET_NAME',
      'SET_FAMILY',
      'SET_EMAIL',
      'SET_DEPARTMENT',
      'SET_ORGANIZATION',
      'SET_POSITION',
    ]),
    set_family(ev) {
      this.register_info.family = ev;
    },
    set_name(ev) {
      this.register_info.name = ev;
    },
    set_email(ev) {
      this.register_info.email = ev;
    },
    set_directorate(ev) {
      // this.user.directorate ? this.user.directorate : this.user.organization.name
      this.register_info.directorate = ev;
    },
    set_org(ev) {
      this.register_info.organization = ev;
    },
    set_position(ev) {
      this.register_info.position = ev;
    },
    event_type(ev) {
      if (ev=='Онлайн') {
        this.registered_event.format = 'online';
      } else if (ev=='Офлайн') {
        this.registered_event.format = 'offline';
      } else {
        this.registered_event.format = 'online_reg';
      }
    },
  },
};


</script>
